import { ELanguage } from '@portals/help-center-core';

export const getValidLocale = (locale: ELanguage): ELanguage => {
  if (locale === ELanguage.CHINESE) {
    return ELanguage.CHINESE_CORRECT;
  }

  return locale;
};
